import styles from './styles/SubItems.module.scss';
import React from 'react';
const widths = [8, 6, 7, 5, 7, 6];
export const SubItemsSkeleton = () => {
    return (React.createElement("ul", { className: `list:none d:grid gaf:column jc:start ov:h pev:none lh:0 ${styles.items}` }, widths.map((w, i) => (React.createElement("li", { key: i, className: `pos:r skeleton bdrs:2 bxz:cb ${styles.itemWrapper} ${styles.item}`, style: { width: `${w}em` } })))));
};
